const getCSSColor = (varName) => {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(varName)
      .trim();
    return value || "#000000";
  }
};

export const colors = {
  // Primary colors
  primary: () => getCSSColor("--color-primary"),
  success: () => getCSSColor("--color-success"),
  error: () => getCSSColor("--color-error"),
  info: () => getCSSColor("--color-info"),
  warning: () => getCSSColor("--color-warning"),

  // Neutral colors
  white: () => getCSSColor("--color-white"),
  gray50: () => getCSSColor("--color-gray-50"),
  gray100: () => getCSSColor("--color-gray-100"),
  gray200: () => getCSSColor("--color-gray-200"),
  gray300: () => getCSSColor("--color-gray-300"),
  gray400: () => getCSSColor("--color-gray-400"),
  gray500: () => getCSSColor("--color-gray-500"),
  gray600: () => getCSSColor("--color-gray-600"),
  gray700: () => getCSSColor("--color-gray-700"),
  gray800: () => getCSSColor("--color-gray-800"),
  gray900: () => getCSSColor("--color-gray-900"),

  // Base colors
  red400: () => getCSSColor("--color-red-400"),
  red500: () => getCSSColor("--color-red-500"),
  green400: () => getCSSColor("--color-green-400"),
  green500: () => getCSSColor("--color-green-500"),
  blue200: () => getCSSColor("--color-blue-200"),
  blue300: () => getCSSColor("--color-blue-300"),
  blue400: () => getCSSColor("--color-blue-400"),
  blue500: () => getCSSColor("--color-blue-500"),
  yellow500: () => getCSSColor("--color-yellow-500"),
  yellow300: () => getCSSColor("--color-yellow-300"),
  purple500: () => getCSSColor("--color-purple-500"),
  magenta400: () => getCSSColor("--color-magenta-400"),
  magenta500: () => getCSSColor("--color-magenta-500"),
  orange500: () => getCSSColor("--color-orange-500"),
  indigo50: () => getCSSColor("--color-indigo-50"),

  sphere: () => colors.purple500(),
  cube: () => colors.blue300(),
  cylinder: () => colors.green500(),
  cone: () => colors.yellow500(),
  pyramid: () => colors.red500(),
  torus: () => colors.magenta500(),
  handleX: () => colors.red400(),
  handleY: () => colors.green400(),
  handleZ: () => colors.blue400(),
  handleAll: () => colors.magenta400(),
  selection: () => colors.indigo50(),
  border: () => colors.gray800(),

  rooftopPolygon: () => colors.blue400(),

  hoveredObject: () => colors.yellow300(),
  clickedObject: () => colors.yellow500(),
  selectedObject: () => colors.red500(),
  defaultObject: () => colors.blue200(),
  unclickableObject: () => colors.gray900(),
};

export default getCSSColor;
